export const tables = {
    'No data': 'No se encontraron datos',
    'Click to cancel sort': ' Haz clic para cancelar la ordenación',
    'Click sort by ascend': 'Haz clic en ordenar por ascender',
    'Click sort by descend': 'Haz clic en ordenar por descender'
};